import { appName } from '@/ui/utils/utils';
import { ContactManagementConfigProvider } from '@juvare/contact-management/ui/providers';
import React, { PropsWithChildren } from 'react';

export const ContactManagementConfigProviderPublic: React.FC<PropsWithChildren> = ({ children }) => {
    return <ContactManagementConfigProvider appName={appName}>{children}</ContactManagementConfigProvider>;
};
